import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

/**
 * @slot - wb-radio-button elements placed within the element
 */
@Component({
  tag: 'wb-radio-group',
  styleUrl: 'radio-group.scss',
  shadow: true,
})
export class RadioGroupComponent implements ComponentInterface {
  /** label of the fieldset grouping the radio buttons */
  @Prop({ reflect: true })
  public label: string;

  /** horizontal orientation for the radio buttons */
  @Prop({ reflect: true })
  public horizontal: boolean;

  public render(): JSX.Element {
    return (
      <Host class="wb-radio-group">
        <fieldset role="radiogroup">
          {this.label && <legend>{this.label}</legend>}
          <slot />
        </fieldset>
      </Host>
    );
  }
}
